import { useEffect, useRef } from 'react';
function useRadioGroupFocusRef() {
    var radioGroupRef = useRef(null);
    useEffect(function () {
        if (radioGroupRef.current) {
            var firstRadio = radioGroupRef.current.querySelector('input[type="radio"]');
            firstRadio === null || firstRadio === void 0 ? void 0 : firstRadio.focus();
        }
    }, []);
    return radioGroupRef;
}
export default useRadioGroupFocusRef;
//# sourceMappingURL=use-radio-group-focus-ref.js.map